/* eslint-disable no-magic-numbers */
/* eslint-disable complexity */
import clsx from 'clsx';
import React from 'react';

import { useIntl } from '@futrli/localisation';
import { ForecastListItem } from '@futrli-sdk/predict';
import { ConsolidatedForecastListItem } from '@futrli-sdk/consolidations';

import { AxisOptions, DataField, FinData, ROUNDING_OPTIONS, VALUE_DISPLAY_OPTIONS, VALUE_TREATMENT } from '../../types';
import { calculateData } from '../../utils-generic';
import { EditableTitles } from '../editable-titles/editable-titles';
import { useI18nConstants } from '../../use-i18n-constants';

import styles from './data-card.scss';

interface Props {
  title: string;
  data: (FinData | undefined)[];
  fields: DataField[];
  primaryAxisOptions: AxisOptions | undefined;
  selectedForecasts: (ForecastListItem | ConsolidatedForecastListItem)[];
  currency: string;
  viewOnly?: boolean;
}
export const DataCard = ({ title, data, fields, primaryAxisOptions, currency, selectedForecasts, viewOnly }: Props) => {
  const intl = useIntl();
  const { roundAndFormatValue } = useI18nConstants();
  let unit = primaryAxisOptions?.unit;
  if (!unit) {
    const isCurrency = fields.some(f => data[0]?.field_meta?.[f.ref]?.display_type === VALUE_DISPLAY_OPTIONS.CURRENCY);
    const isPercentage = fields.some(
      f => data[0]?.field_meta?.[f.ref]?.display_type === VALUE_DISPLAY_OPTIONS.PERCENTAGE
    );
    unit = isCurrency
      ? VALUE_DISPLAY_OPTIONS.CURRENCY
      : isPercentage
      ? VALUE_DISPLAY_OPTIONS.PERCENTAGE
      : VALUE_DISPLAY_OPTIONS.NUMBER;
  }

  return (
    <div className={clsx(styles.dataCards)} tabIndex={0}>
      {!viewOnly ? <EditableTitles title={title} viewOnly={!!viewOnly} isDataCard /> : <h3>{title}</h3>}
      <div className={clsx(styles.dataCardsContainer)}>
        {selectedForecasts.map(f => {
          const forecastData = data.find(d => d?.forecastId === f.id);
          return (
            <div className={clsx(styles.dataCard)} key={f.id}>
              <p className={clsx(styles.value)}>
                {roundAndFormatValue(
                  calculateData(
                    Object.keys(forecastData?.fields || {})
                      .map(k => forecastData?.fields?.[k] || [])
                      .reduce((acc, cur) => [...cur, ...acc], []),
                    primaryAxisOptions?.valueTreatment || VALUE_TREATMENT.SUM
                  ),
                  primaryAxisOptions?.rounding || ROUNDING_OPTIONS.INTEGER,
                  unit as VALUE_DISPLAY_OPTIONS,
                  intl,
                  currency
                )}
              </p>
              {selectedForecasts.length > 1 && <p className={clsx(styles.forecastName)}>{f.name}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
